import {
    faQuestionCircle,
    faEnvelope,
    faCalendar,
    faChartBar,
    faUser,
    faClipboard,
} from '@fortawesome/free-regular-svg-icons'
import {
    faDashboard,
    faUsers,
    faSterlingSign,
    faCar,
    faUserLock,
    faBackward,
    faBoxOpen,
    faFileSignature,
} from '@fortawesome/free-solid-svg-icons'
import { NavItem } from '../shared/components/sidebar/nav-item.interface'

export const secureNavItems: NavItem[] = [
    {
        name: 'Dashboard',
        url: '/dashboard',
        faIcon: faDashboard,
    },
    {
        name: 'Diaries',
        url: '/diary',
        groupLink: '/diary/calendar',
        faIcon: faCalendar,
        children: [
            {
                name: 'Diary',
                url: '/diary/timeline',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Out of Hours',
                url: '/diary/on-call-diary',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Holidays',
                url: '/diary/holiday',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Absences',
                url: '/diary/absence',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Optimised Routing',
                url: '/diary/optimise-route',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Timeslot SMS',
                url: '/diary/timeslot-sms',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Unallocated',
                url: '/unallocated-appointments',
                icon: 'nav-icon-bullet',
                // attributes: {
                //     disabled: true,
                // },
            },
        ],
    },
    {
        name: 'Posts',
        url: '/posts',
        faIcon: faEnvelope,
        badge: {
            color: 'danger',
            text: '0',
        },
        counterKey: 'posts',
    },
    {
        name: 'Customers',
        url: '/customers',
        groupLink: '/customers/all',
        faIcon: faUsers,
        children: [
            {
                name: 'Find Customer',
                url: '/customers/all',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Add Customer',
                url: '/customers/0/details',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Recent Customers',
                action: 'recent-customers',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Merge Customer',
                url: '/customers/merge',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Properties',
                url: '/sites',
                icon: 'nav-icon-bullet',
                badge: {
                    color: 'info',
                    text: 'NEW',
                },
            },
            {
                name: 'Appliance Reminders',
                url: '/appliance-reminders',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Email History',
                url: '/emails',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'SMS History',
                url: '/sms',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'SSP',
                url: '/ssp',
                icon: 'nav-icon-bullet',
                permissions: ['SSP'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Directory',
                url: '/directory',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Wildix',
                url: '/wildix',
                icon: 'nav-icon-bullet',
                permissions: ['WILDIX'],
                permissionStrategy: 'disable',
            },
        ],
    },
    {
        name: 'Jobs & Quotes',
        url: '/jobs-and-quotes',
        faIcon: faClipboard,
        children: [
            {
                name: 'Smart Quotes',
                url: '/smartquotes',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Estimates',
                url: '/jobs-and-quotes/estimates',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Booking Engine',
                url: '/jobs-and-quotes/booking-engine',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Air Quotes',
                url: '/air-quotes',
                icon: 'nav-icon-bullet',
                permissions: ['AirQuote'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Finance Calculator',
                url: '/jobs-and-quotes/finance-calculator',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Surequote',
        faIcon: faFileSignature,
        permissions: ['SurequoteLinked'],
        permissionStrategy: 'remove',
        children: [
            {
                name: 'Quote Wizard',
                url: '/surequote-quotes',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Parts & Inventory',
        url: '/inventory',
        faIcon: faBoxOpen,
        permissionStrategy: 'disable',
        children: [
            {
                name: 'Stock Control',
                url: '/inventory/assets',
                icon: 'nav-icon-bullet',
                permissions: ['StockControl'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Wolseley Order',
                url: '/wolseley-order',
                icon: 'nav-icon-bullet',
                permissions: ['Wolseley'],
                permissionStrategy: 'disable',
            },
            {
                name: 'Orders Placed',
                url: '/orders',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Parts Arena',
                url: '/products/parts-arena',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Staff',
        url: '/staff',
        faIcon: faUser,
        children: [
            {
                name: 'Find Staff',
                url: '/staff/all',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Add Staff',
                url: '/staff/0/details',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Holidays',
                url: '/staff/holidays',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Absences',
                url: '/staff/absences',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Map Tracking',
                url: '/staff/tracking',
                icon: 'nav-icon-bullet',
            },
        ],
    },
    {
        name: 'Accounting',
        faIcon: faSterlingSign,
        children: [
            {
                name: 'Accounts Integration',
                url: '/accounts-integration',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Surefire Accounts',
                url: '/surefire-accounts',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Payments',
                url: '/payments',
                icon: 'nav-icon-bullet',
            },
            // {
            //     name: 'Staff Timesheets',
            //     url: '/staff-timesheets',
            //     icon: 'nav-icon-bullet',
            // },
        ],
    },
    {
        name: 'Fleet Manager',
        faIcon: faCar,
        url: '/vehicle-tracking',
        permissions: ['Quartix'],
        permissionStrategy: 'disable',
    },
    {
        name: 'Help',
        url: '/help',
        faIcon: faQuestionCircle,
        children: [
            {
                name: 'Contact Support',
                url: '/help/contact-support',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Surefire Docs',
                href: 'https://surefire-software.gitbook.io/docs/',
                icon: 'nav-icon-bullet',
            },
            {
                name: 'Notice Board',
                icon: 'nav-icon-bullet',
                url: '/notices',
            },
            {
                name: 'Release Notes',
                icon: 'nav-icon-bullet',
                url: '/release-notes',
            },
        ],
    },
    {
        name: 'Reports',
        url: '/reports/all',
        faIcon: faChartBar,
    },
    {
        title: true,
        name: 'Apps',
    },
    {
        name: 'Surequote',
        faIcon: faFileSignature,
        url: '/apps/surequote',
    },
    {
        name: 'Classic Surefire (V2)',
        href: 'https://sf.surefiresoftware.co.uk/',
        faIcon: faBackward,
    },
    {
        title: true,
        name: 'Support',
        roles: ['SUPPORT'],
    },
    {
        name: 'Support',
        faIcon: faUserLock,
        url: '/support',
        roles: ['SUPPORT'],
    },
    {
        title: true,
        name: 'Billing',
        roles: ['SUPPORT'],
    },
    {
        name: 'Billing',
        faIcon: faUserLock,
        url: '/billing',
        roles: ['SUPPORT'],
    },
]
